import axios from "axios";

const URL_MONGO = import.meta.env.VITE_URL_MONGO;

export const GetUsersCity = (arg) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(arg);
      const rta = await axios.get(`${URL_MONGO}/ptsciudades/${arg}`);

      resolve(rta);
    } catch (error) {
      console.log("GetUsersCity:", error);
      reject(error);
    }
  });
};
